import dayjs from 'dayjs';



const canInteractWithSchedule = (schedule, accountIsPublished = true) => {
  if (accountIsPublished && !schedule.is_published) {
    return true;
  }
  let updateTimestamp = dayjs();
  const scheduledDate = dayjs(schedule.scheduled_at);
  const useUtcZeroTime = schedule.use_utc_zero_time;

  if (!useUtcZeroTime) {
    // we use +13 hours instead of +12 to include a 1-hour buffer
    updateTimestamp = updateTimestamp.add(13, 'hour');
  } else {
    // we use +1 hour to include a 1-hour buffer
    updateTimestamp = updateTimestamp.add(1, 'hour');
  }

  return updateTimestamp.isBefore(scheduledDate);
};

export default canInteractWithSchedule;
